import React from 'react';
import { Typography } from '@mui/material';
import { PuiButton, PuiDialog, PuiGrid } from "@portnet/ui";
import ReportProblemIcon from '@mui/icons-material/ReportProblem'; // Warning icon

const DialogImportant = ({ open, close, text, confirmation, confirmOk }) => {
    const titleElement = (
        <PuiGrid container alignItems="center" spacing={1}>
            <PuiGrid item>
                <ReportProblemIcon style={{ color: 'red', fontSize: '30px' }} />
            </PuiGrid>
            <PuiGrid item>
                <Typography variant="h6" style={{ color: 'red', fontWeight: 'bold' }}>
                    Attention
                </Typography>
            </PuiGrid>
        </PuiGrid>
    );

    return (
        <PuiDialog
            onClose={close}
            open={open}
            maxWidth="md" // Increased size from "sm" to "md"
            fullWidth
            title={titleElement}
            style={{
                backdropFilter: 'blur(4px)', // Eclipse effect for background
                backgroundColor: 'rgba(0, 0, 0, 0.8)', // Semi-transparent black background
            }}
        >
            <PuiGrid container justifyContent="center" style={{ margin: '20px 0' }}>
                <PuiGrid item>
                    <Typography style={{ textAlign: 'center', color: 'black', fontSize: '16px' }}>
                        {text}
                    </Typography>
                </PuiGrid>
            </PuiGrid>
            {confirmation && (
                <PuiGrid container justifyContent="flex-end" spacing={2} marginTop={2}>
                    <PuiGrid item>
                        <PuiButton
                            color="tertiary"
                            onClick={close}
                            style={{
                                marginRight: '10px',
                                fontWeight: 'bold',
                                textTransform: 'none',
                            }}
                        >
                            Non
                        </PuiButton>
                    </PuiGrid>
                    {confirmOk && (
                        <PuiGrid item>
                            <PuiButton
                                onClick={confirmOk}
                                style={{
                                    backgroundColor: 'red',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    textTransform: 'none',
                                    ':hover': { backgroundColor: 'darkred' },
                                }}
                            >
                                Oui
                            </PuiButton>
                        </PuiGrid>
                    )}
                </PuiGrid>
            )}
        </PuiDialog>
    );
};

export default DialogImportant;